import { Box, Button, Flex, HStack, Text, useToast, VStack } from "@chakra-ui/react";
import { RightSidebarHeader } from "components/Layout/RightSidebarWidget";
import { File, Info, LinkSimple, X } from "@phosphor-icons/react";
import MarkdownText from "components/MarkdownText";
import { useAuth } from "context";
import { apiArchiveFileInfo } from "api/common/fileinfo.service";
import { showErrorToast } from "utils";
import LocalSpinner from "components/AppSpinner/AppSpinner";
import { getFileType } from "api/common/fileinfo";

export default function SourcesTipsSideBar() {
  // HACK if windows is small, return null so as not to block the main content
  const isSmallWindow = window.innerWidth < 1480;
  if (isSmallWindow) {
    return null;
  }
  return (
    <Box /* TODO: refactor to avoid local styles for better consistency, reusability, maintenance */
      bg="gray.50"
      borderLeft="1px solid"
      borderColor="gray.200"
      overflowY="auto"
      maxW="450px"
      minW="350px"
      height="100vh"
      right={0}
      top={0}
      position="absolute"
      // top={0}
      //   height="100vh"
      p={4}
    >
      {/* Tips Section */}
      <Flex gap={4} direction="column">
        <RightSidebarHeader Icon={Info}>Tips</RightSidebarHeader>
        <MarkdownText fontSize="body.s">
          {`
Here are some recommended files to upload if available:

- Sustainability Reports
- Carbon Emission Data
- Financial Statements
- Risk Assessment Reports
- Employee Data Reports 
- Supplier Data
- Corporate Governance Documents
- Policy Documents
- Audit and Verification Reports
`}
        </MarkdownText>
      </Flex>
    </Box>
  );
}
